<template>
  <BaseNote id="simple4" :note="note" :selected="selected" v-on="$listeners" />
</template>

<script>
import BaseNote from "../../../components/Note/BaseNote.vue"

export default {
  components: {
    BaseNote
  },
  props: {
    note: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.ag-block--note-simple4 {
  @apply relative overflow-hidden rounded-lg pt-48 ring-2 ring-inset ring-gray-200;

  .ag-block__featured-image {
    @apply absolute inset-x-0 top-0 h-48;

    img {
      @apply h-full w-full object-cover;
    }
  }

  .ag-block__body {
    @apply w-full p-8;
  }
}
</style>
